import { forwardRef, type JSX } from 'react';
import { trackEvent } from 'services/Gtm/functions';
import type { EventData } from 'services/Gtm/entities';
import * as S from './CrashCoursesDropdownStyles';

export interface CrashCourseDropdownProps {
  label: string;
  children?: JSX.Element;
  trackingData: EventData;
  isOpened: boolean;
  onOpen: () => void;
}

const CrashCourseDropdown = forwardRef<HTMLSpanElement, CrashCourseDropdownProps>(
  ({ label, children, trackingData, isOpened, onOpen }, ref) => (
    <S.CrashCourseDropdownWrapper
      data-cy='crashCourseDropdown'
      ref={ref}
    >
      <S.CrashCourseDropdownLabel
        onClick={() => {
          onOpen();
          if (trackEvent)
            trackEvent({
              ...trackingData,
              contentPlacementCD: 'top of grid filter',
              eventAction: 'filter toggle',
              eventLabel: !isOpened ? 'show' : 'hide',
            });
        }}
      >
        {label}
        <S.Icon className={isOpened ? 'up' : 'down'} />
      </S.CrashCourseDropdownLabel>
      {isOpened && <S.CrashCourseDropdownContent>{children}</S.CrashCourseDropdownContent>}
    </S.CrashCourseDropdownWrapper>
  ),
);

CrashCourseDropdown.displayName = 'CrashCourseDropdown';

export default CrashCourseDropdown;
